import React from 'react'
import { withTranslation } from 'react-i18next'
import { PageHeading, ArchiveExpo, PublicationList } from '../components/Fragments'
import { publications, publicationList } from '../data/archive'

function Archive({ t }) {
  return (
    <>
      <PageHeading pageTitle='menu.archive' acronym='acronym' researchCenter='cavas_research_center' />

      <PublicationList list={publicationList} />

      {/* <ArchiveExpo list={publications} /> */}
    </>
  )
}

export default withTranslation()(Archive)
